import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Button from "react-bootstrap/Button";
import Col from 'react-bootstrap/Col';
import ProgressBar from 'react-bootstrap/ProgressBar';
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";

import FatButton from "../../buttons/fat-button/FatButton";
import FilesList from "./fileslist/FilesList";
import {CreateSchemaContext} from './context/CreateSchemaContext';
import {WizardStepProps} from "../../wizard/Wizard";
import {CreateSchemaWizardLeavingConfirmationMessage} from "./CreateSchemaWizard";
import {UnsavedChangesConfirmation} from "../../../common/NavigationConfirmation";
import OntologyFilesUpload from "./fileupload/OntologyFilesUpload";

/**
 * Step implementation dealing with uploading and importing of ontologies.
 */
class UploadOntologiesStep extends React.Component<RouteComponentProps & WizardStepProps> {

  static contextType = CreateSchemaContext;

  /**
   * Next step should be forbidden until at least one file is uploaded.
   */
  isValidated = () => {
    if (this.context.files.length && !this.context.uploading) {
      this.props.next(true);
    }
  };

  onReject = () => {
    this.props.history.goBack();
  };

  render() {
    const {uploading, progress} = this.context;
    return (
      <>
      <Container className="UploadOntologiesStep no-padding" fluid>
        <Row className="pb-3" noGutters>
          <Col>
            <div className="StepActions">
              <Button className="reject prev-btn"
                      disabled={false}
                      onClick={this.onReject}
                      title="Reject">
                Reject
              </Button>
              <Button className="proceed next-btn"
                      disabled={this.context.files.length === 0 || this.context.uploading}
                      onClick={this.isValidated}
                      title="Proceed">
                Proceed
              </Button>
            </div>
          </Col>
        </Row>
        <Row xl={3} lg={3} md={2} sm={1} xs={1}>
          <Col>
            <OntologyFilesUpload/>
          </Col>
          <Col>
            <FatButton className="upload-url-btn" icon="link"
                       title="Upload from URL"
                       descr="All RDF formats"/>
          </Col>
          <Col>
            <FatButton className="import-snippet-btn" icon="pencil-alt"
                       title="Import RDF text snippet"
                       descr="Type or paste RDF data"/>
          </Col>
        </Row>
        <Row>
          <Col className="pt-3">{
            uploading ?
              <ProgressBar variant="success" min={0} max={100} now={progress}
                           label={`${Math.round(progress)}%`}/>
              : ''
          }
          </Col>
        </Row>
        <Row>
          <Col className="my-3 py-3">
            <FilesList/>
          </Col>
        </Row>
      </Container>
      <UnsavedChangesConfirmation when={this.context.files.length}
                                  message={CreateSchemaWizardLeavingConfirmationMessage}/>
      </>
    );
  }
}

export default withRouter(UploadOntologiesStep);
